<template>
  <v-row no-gutters class="text-right" align="center">
    <v-menu open-on-hover top offset-y>
      <template v-slot:activator="{ on }">
        <v-col v-on="on" v-if="usageBudgetPersen(val1, val2) === '-'">
          <v-row
            no-gutters
            class="fs-14"
            align="center"
            justify="end"
            style="width: 60px;"
          >
            <v-col class="teal--text">
              0%
            </v-col>
            <v-col class="pl-1 mt-1">
              <img src="@/assets/images/icon/arrow-up.png" width="17px" />
            </v-col>
          </v-row>
        </v-col>
        <v-col v-on="on" v-else-if="usageBudgetPersen(val1, val2) < 0">
          <v-row
            no-gutters
            class="fs-14"
            align="center"
            justify="end"
            style="width: 60px;"
          >
            <v-col class="teal--text">
              {{ usageBudgetPersen(val1, val2) + '%' }}
            </v-col>
            <v-col class="pl-1 mt-1">
              <img src="@/assets/images/icon/arrow-up.png" width="17px" />
            </v-col>
          </v-row>
        </v-col>
        <v-col v-on="on" v-else-if="usageBudgetPersen(val1, val2) > 0">
          <v-row
            no-gutters
            class="fs-14"
            align="center"
            justify="end"
            style="width: 60px;"
          >
            <v-col class="softRed--text">
              {{ usageBudgetPersen(val1, val2) + '%' }}
            </v-col>
            <v-col class="pl-1 mt-1">
              <img src="@/assets/images/icon/arrow-down.png" width="17px" />
            </v-col>
          </v-row>
        </v-col>
      </template>
      <v-card flat outlined :elevation="0">
        <v-card-title
          class="blue-grey lighten-5 fs-10 pa-0 grey--text text--darken-1"
        >
          <span class="pl-2">REMAINING</span>
        </v-card-title>
        <v-card-text class="fs-10 grey--text text--darken-1 pa-2">
          <v-flex xs12>
            <v-icon color="bluePurple"> fiber_manual_record</v-icon>
            <span>Remaining / Budget</span>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-menu>
  </v-row>
</template>

<script>
export default {
  props: {
    val1: {
      type: Number,
      required: true
    },
    val2: {
      type: Number,
      required: true
    }
  }
};
</script>
<style>
.v-icon.v-icon {
  font-size: 15px !important;
}
.v-menu__content {
  border-radius: 10px !important;
}
</style>
